import { APP_IDS } from "../shared/appIds";

export const TIMELY_APP = Object.freeze({
  id: APP_IDS.TIMELY,
  brandName: "Timely365",
  shortBrandName: "Timely365",
  brandLabel: "Booking",
  verticalId: "booking",
  hosts: Object.freeze([
    "timely365.com",
    "www.timely365.com",
    "booking.timely365.com",
  ]),
  publicHost: "timely365.com",
  publicHomePath: "/",
  businessHomePath: "/biz/bookingtypes?v=booking",
  ownsRoutePrefixes: Object.freeze([
    "/booking",
    "/biz/bookingtypes",
    "/biz/calendar",
    "/biz/capture",
    "/biz/printview",
    "/biz/create",
    "/biz/update",
    "/myschedule",
  ]),
  features: Object.freeze({
    planyAssistant: false,
    productSwitcher: false,
    bookingProviderSettings: false,
  }),
});
